module.exports = __webpack_public_path__ + "img/43-santaclause.8dfc8d90.svg";